import { Injectable } from '@angular/core';
import {
	CanActivate,
	ActivatedRouteSnapshot,
	RouterStateSnapshot,
	Router
} from '@angular/router';
import { AuthService } from '../services/auth.service';
import { RcService } from '../services/rc.service';

@Injectable({
	providedIn: 'root'
})
export class AuthGuard implements CanActivate {
	constructor(
		private readonly authService: AuthService,
		private readonly rcService: RcService,
		private readonly router: Router
	) {}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): boolean {
		// Check authentication status first
		if (this.authService.isAuthenticated()) {
			return true;
		}

		// Check if we're on localhost
		const isLocalhost =
			window.location.hostname.includes('localhost') ||
			window.location.hostname.includes('127.0.0.1');

		if (isLocalhost || window.location.hostname === 'rms.katdev.com') {
			// For localhost, redirect directly to login without RC
			this.router.navigate(['/auth/login'], { replaceUrl: true });
			return false;
		}

		// For server environments, handle RC-based routing
		const rcParam = route.params['rc'];

		if (!rcParam) {
			// No RC parameter, redirect to select-rc
			this.router.navigate(['/select-rc'], { replaceUrl: true });
			return false;
		}

		// Validate RC before redirecting
		if (!this.rcService.isValidRc(rcParam)) {
			this.router.navigate(['/select-rc'], { replaceUrl: true });
			return false;
		}

		// Set the RC and redirect to login with RC in URL
		this.rcService.setRc(rcParam);
		localStorage.setItem('currentRc', rcParam);

		// Redirect to login with RC, using replaceUrl to avoid adding to history
		this.router.navigate([`/${rcParam}/auth/login`], { replaceUrl: true });
		return false;
	}
}
